import { Text } from '@cuemath/web-comps';
import {
  DropdownMenu as SementicDropdownMenu,
  DropdownItem as SementicDropdownItem,
} from 'semantic-ui-react';
import styled from 'styled-components';

export const DropdownMenu = styled(SementicDropdownMenu)`
  top: ${({ top }) => (top ? top : '40px !important')};
  padding: 8px 0px !important;
  width: 256px;
  height: fit-content;
  display: block;
  left: ${({ left }) => (left ? left : 'auto')} !important;
  right: ${({ right }) => (right ? right : 'auto')} !important;
`;

export const DropdownItem = styled(SementicDropdownItem)`
  border-radius: 0px !important;
  padding: 8px 16px !important;
`;

export const DropdownText = styled(Text)`
  padding: 0 4px;
`;
